import { render } from "./Home.vue?vue&type=template&id=a5b65842"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=a5b65842&lang=scss"
script.render = render

export default script